// Moji Notification Sounds - Web Audio API generated tones with Theme Support
let audioContext = null;

function getAudioContext() {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
  if (audioContext.state === 'suspended') {
    audioContext.resume();
  }
  return audioContext;
}

function playTone(frequency, duration, type = 'sine', volume = 0.3, delay = 0) {
  try {
    const ctx = getAudioContext();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.type = type;
    osc.frequency.setValueAtTime(frequency, ctx.currentTime + delay);
    gain.gain.setValueAtTime(volume, ctx.currentTime + delay);
    gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + delay + duration);

    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.start(ctx.currentTime + delay);
    osc.stop(ctx.currentTime + delay + duration);
  } catch (e) {
    // Silently fail
  }
}

// Sound theme definitions
const SOUND_THEMES = {
  default: {
    label: "Default",
    icon: "🔔",
    message: () => {
      playTone(880, 0.12, 'sine', 0.2, 0);
      playTone(1174.66, 0.18, 'sine', 0.15, 0.08);
    },
    payment: () => {
      playTone(523.25, 0.1, 'triangle', 0.25, 0);
      playTone(659.25, 0.1, 'triangle', 0.25, 0.1);
      playTone(1046.5, 0.25, 'triangle', 0.2, 0.2);
    },
    friendRequest: () => {
      playTone(659.25, 0.3, 'sine', 0.2, 0);
    },
    reaction: () => {
      playTone(1318.5, 0.08, 'sine', 0.15, 0);
    }
  },
  retro: {
    label: "Retro 8-bit",
    icon: "🕹️",
    message: () => {
      playTone(440, 0.06, 'square', 0.12, 0);
      playTone(660, 0.06, 'square', 0.12, 0.07);
      playTone(880, 0.1, 'square', 0.1, 0.14);
    },
    payment: () => {
      playTone(330, 0.05, 'square', 0.15, 0);
      playTone(440, 0.05, 'square', 0.15, 0.06);
      playTone(550, 0.05, 'square', 0.15, 0.12);
      playTone(660, 0.05, 'square', 0.15, 0.18);
      playTone(880, 0.15, 'square', 0.12, 0.24);
    },
    friendRequest: () => {
      playTone(523.25, 0.08, 'square', 0.12, 0);
      playTone(659.25, 0.12, 'square', 0.1, 0.1);
    },
    reaction: () => {
      playTone(1046.5, 0.05, 'square', 0.1, 0);
      playTone(1318.5, 0.05, 'square', 0.1, 0.06);
    }
  },
  nature: {
    label: "Nature",
    icon: "🌿",
    message: () => {
      playTone(396, 0.25, 'sine', 0.15, 0);
      playTone(528, 0.3, 'sine', 0.12, 0.15);
    },
    payment: () => {
      playTone(264, 0.2, 'sine', 0.18, 0);
      playTone(330, 0.2, 'sine', 0.15, 0.18);
      playTone(396, 0.35, 'sine', 0.12, 0.36);
    },
    friendRequest: () => {
      playTone(352, 0.4, 'sine', 0.12, 0);
    },
    reaction: () => {
      playTone(792, 0.15, 'sine', 0.1, 0);
    }
  },
  minimal: {
    label: "Minimal",
    icon: "◻️",
    message: () => {
      playTone(1000, 0.06, 'sine', 0.1, 0);
    },
    payment: () => {
      playTone(800, 0.05, 'sine', 0.12, 0);
      playTone(1200, 0.08, 'sine', 0.1, 0.08);
    },
    friendRequest: () => {
      playTone(600, 0.1, 'sine', 0.1, 0);
    },
    reaction: () => {
      playTone(1500, 0.04, 'sine', 0.08, 0);
    }
  }
};

function getCurrentTheme() {
  const id = localStorage.getItem('moji_sound_theme') || 'default';
  return SOUND_THEMES[id] || SOUND_THEMES.default;
}

export function playMessageSound() {
  if (!isSoundEnabled()) return;
  getCurrentTheme().message();
}

export function playPaymentSound() {
  if (!isSoundEnabled()) return;
  getCurrentTheme().payment();
}

export function playFriendRequestSound() {
  if (!isSoundEnabled()) return;
  getCurrentTheme().friendRequest();
}

export function playReactionSound() {
  if (!isSoundEnabled()) return;
  getCurrentTheme().reaction();
}

export function isSoundEnabled() {
  return localStorage.getItem('moji_sound_enabled') !== 'false';
}

export function setSoundEnabled(enabled) {
  localStorage.setItem('moji_sound_enabled', enabled ? 'true' : 'false');
}

export function getSoundTheme() {
  return localStorage.getItem('moji_sound_theme') || 'default';
}

export function setSoundTheme(themeId) {
  localStorage.setItem('moji_sound_theme', themeId);
}

export function getSoundThemes() {
  return Object.entries(SOUND_THEMES).map(([id, theme]) => ({
    id,
    label: theme.label,
    icon: theme.icon
  }));
}

export function previewTheme(themeId) {
  const theme = SOUND_THEMES[themeId];
  if (theme) theme.message();
}

export function warmUpAudio() {
  try {
    const ctx = getAudioContext();
    const buffer = ctx.createBuffer(1, 1, 22050);
    const source = ctx.createBufferSource();
    source.buffer = buffer;
    source.connect(ctx.destination);
    source.start(0);
  } catch (e) {
    // Silently fail
  }
}
